import { render, staticRenderFns } from "./MonitoringGauge.vue?vue&type=template&id=70156b0a&scoped=true&"
import script from "./MonitoringGauge.vue?vue&type=script&lang=ts&"
export * from "./MonitoringGauge.vue?vue&type=script&lang=ts&"
import style0 from "./MonitoringGauge.vue?vue&type=style&index=0&id=70156b0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70156b0a",
  null
  
)

export default component.exports